<template>
  <div class="inactive-portal">
    <div class="row">
      <div class="col-8 alert alert-dark">
        <div class="text-center">Oops it seems like there is a problem.</div>
        <div v-if="consumerErrors.length > 0">
          <div v-for="error in stringErrors" :key="error" class="fw-bold fs-3 text-center">
            {{error}}
          </div>
        </div>
        <br />
        <div class="dog-container text-center">
          <img :src="doggy" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'InactivePortal',
  props: [],
  data () {
    return {
      doggy: process.env.BASE_URL + 'leadhoop_sleep.png'
    }
  },
  computed: {
    stringErrors () {
      return this.consumerErrors.filter((e) => typeof e === 'string')
    },
    ...mapState({
      consumerErrors: state => state.consumer.consumerErrors
    })
  },
  methods: {
    async triggerResizeEvent () {
      setTimeout(function () {
        window.dispatchEvent(new Event('resize'))
      }, 500)
    }
  },
  mounted () {
    this.triggerResizeEvent()
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
.alert-dark {
  background-color:  white;
  border: 1px solid #337ab7;
  color: #333
}
</style>
